/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ScreenArrowIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABN0lEQVR4nN2UzUrEQAzH9+RFT3oT9gEEUfCgBxXxsKftJKkwkxTckw9jPfoe+xQuvokfoOzFU0GhktXCsuvUmbbCYiCUaZj/r0mT9Hr/xqy1a0B8Y5CfgKRs4ob4EUhy1VoCaCBCrACS95p4vgT4poeJg2wnqTsA4ldfJj9lEFYGlA8Vn32UkT0fpDEA1FFehqnb1XtEvAMoz20BhUG+BZCjweByffEuUXbYBvAwTN1+XQeaC3fcFFBU4ojcB+KxIXmbL5E+9dwIoGWpxA3KtHqfUHZWJx4M0Np+xXi8AL4CcOc+8WCAtXZjVmMtS+RUBw1aQtkJIp/GivsGLWZVlL8M47Vn2UkesTLKqGW3EmZQpup/BgBfh3RhRKOtufbd7EzYkNx7fyzypDUAkCf+rpG7TrJYafsEzvYMR0rHD7gAAAAASUVORK5CYII=)
 */
export const ScreenArrowIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Zm16 3a1 1 0 0 0-.3-.7l-3-3a1 1 0 1 0-1.4 1.4L14.58 7H13a6 6 0 0 0-6 6 1 1 0 1 0 2 0 4 4 0 0 1 4-4h1.59l-1.3 1.3a1 1 0 0 0 1.42 1.4l3-3A1 1 0 0 0 18 8Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M13 19.5c0 .28.22.5.5.5H15a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h1.5a.5.5 0 0 0 .5-.5v-2c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v2Z"
        className={colorClass}
      />
    </svg>
  );
};
